import clientInformation, { getClientItem } from '../login/ClientInfo';
import { RequestEWalletPayout, GetPayoutFee } from "../../services/PayoutService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken } from "../../services/AuthenticationService";
import BeatLoader from "react-spinners/BeatLoader";
import { onlyNumbers, BonusString } from '../helpers/common';
import { isMobile } from 'react-device-detect';
import { useTranslations } from '../../context/LanguageContext';
import translations from '../../translations/PayoutWalletMethods';

export const PayoutWalletMethods = () => {
    const t = useTranslations(translations);
    const clientInfo = clientInformation();
    let INSTANCEID = clientInfo.InstanceID;
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isProcessing, setIsProcessing] = useState(false);
    const { id } = useParams();
    const [arrayPayouts, setPayouts] = useState(JSON.parse(getClientItem('arrayPayoutsMethods')).filter(function (element) { return element.PayoutID.toLowerCase() === id.toLowerCase(); })[0]);
    const navigate = useNavigate();
    const [showComponent, setshowComponent] = useState(false);
    const [OriginalAmount, setOriginalAmount] = useState(0);
    const fixedAmount = Number(getClientItem('FixedAmount')) || 0;
    const [amount, setAmount] = useState(fixedAmount > 0 ? fixedAmount : '');

    useEffect(() => {
        IsValidToken(getClientItem('Token')).then(

        )
            .catch(function (error) {
                navigate('/expired/');
            })

        if (arrayPayouts === undefined) {
            navigate('/payouts/');
        }

        ChangeWalletAddressFormat(arrayPayouts?.ImageName)

    }, [])

    async function ChangeWalletAddressFormat(ImageName) {
        const walletInputs = document.getElementsByName("walletaddress");

        if (!walletInputs || walletInputs.length === 0) return;

        const walletInput = walletInputs[0];

        switch (ImageName.toLowerCase()) {
            case "cashapp":
                walletInput.placeholder = t.cashappPlaceholder;
                break;
            case "venmo":
                walletInput.placeholder = t.venmoPlaceholder;
                break;
            case "applepay":
                walletInput.placeholder = t.applePayPlaceholder;
                break;
            case "zelle":
            case "paypal":
                walletInput.placeholder = t.emailPlaceholder;
                break;
            case "tylt":
                walletInput.placeholder = t.tyltPlaceholder;
                break;
            default:
                walletInput.placeholder = t.defaultPlaceholder;
                break;
        }
    }

    async function doRequestEWalletPayout(Amount, walletaddress, comments) {
        if (parseFloat(Amount.replace(",", "").replace(" ", "")) <= parseFloat(clientInfo.WithdrawalBalance.replace(",", "")) && parseFloat(Amount.replace(",", "").replace(" ", "")) > 0) {
            var PayoutData = {
                "Token": getClientItem('Token'),
                "Amount": Amount.replace(",", ""),
                "CurrencyCode": clientInfo.CurrencyCode,
                "ProcessorName": arrayPayouts?.PayoutID,
                "EWalletID": walletaddress,
                "SecureID": "",
                "IPv4Address": clientInfo.IPAddress,
                "Comments": comments
            };

            await RequestEWalletPayout(PayoutData).then(function (response) {

                try {
                    var payload = {
                        TransactionID: response.Authentication.TransactionID,
                        Amount: amount,
                        Status: response.Authentication.Status,
                        ProcessorName: arrayPayouts?.PayoutID
                    }

                    window.parent.postMessage(
                        { 'transactionInfo': payload },
                        '*'
                    );
                }
                catch (error) { }

                if (response.Authentication.ErrorCode === "") {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen(t.withdrawalStatus, response.Authentication.HtmlResponse, 'info');
                    else
                        Alerts.ShowAlert(t.withdrawalStatus, response.Authentication.HtmlResponse, 'info');
                    navigate('/payouts/');
                } else {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen(t.withdrawalStatus, response.Authentication.HtmlResponse, 'warning');
                    else
                        Alerts.ShowAlert(t.withdrawalStatus, response.Authentication.HtmlResponse, 'warning');
                }
            })
                .catch(function (error) {
                    Alerts.ShowAlert(t.withdrawalStatus, error.response.data.Authentication.HtmlResponse, 'error');
                })
        }
        else {
            if (isMobile)
                Alerts.ShowAlertFullScreen(t.withdrawalStatus, t.amountNotPermitted, 'warning');
            else
                Alerts.ShowAlert(t.withdrawalStatus, t.amountNotPermitted, 'warning');
        }

    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount, walletaddress, comments } = Object.fromEntries(data.entries());

            if (amount != '') {
                setIsProcessing(true);
                setOriginalAmount(amount);
                await doRequestEWalletPayout(amount, walletaddress, comments);
                setIsProcessing(false);
            }
            else {
                Alerts.ShowAlert(t.warning, t.amountRequired, 'warning');
            }

        }
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px" }} src={"/svg/" + arrayPayouts?.ImageName + ".svg"} />  <span className="payout-title">{t.withdrawUsing} {arrayPayouts?.PayoutID} </span>
                    </span>
                </div>
                <div className="row">
                    <div className="col-md-6 col-sm-12 mb-3">
                        <input type="text" className="form-control" id="walletaddress" aria-describedby="lblAddress" placeholder={t.walletAddress} name="walletaddress" required="required" />
                    </div>
                    <div className="col-md-6 col-sm-12 m3">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                    <select className="form-control selectcurrency" disabled name="ccCurrency" required value={clientInfo.CurrencyCode}>
                                        <option value="" className="">{t.currency}</option>
                                        <option value="USD">USD</option>
                                    </select>
                                </span>
                            </div>
                            <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder={t.amount} max={arrayPayouts?.MaxPayout === 0 ? MAXLIMIT : arrayPayouts?.MaxPayout} min={arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} name="amount" required="required" value={amount} onChange={(e) => setAmount(e.target.value)} readOnly={fixedAmount > 0} />
                        </div>

                        <div className="d-flex flex-row ml-2 limit-text-center mb-4 ">
                            {t.payoutLimits} {arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} USD {t.maximum} {arrayPayouts?.MaxPayout === 0 ? t.noLimit : arrayPayouts?.MaxPayout + ' USD'}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-sm-12 mb-3">
                        <textarea rows="3" cols="75" className="form-control" id="comments" aria-describedby="lblcomments" placeholder={t.comments} name="comments" required="required" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/payouts/')}>{t.back}</button>
                        <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">{t.submit}</button>
                    </div>
                </div>


            </form>
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>
    );

}
